import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

/** The five reasons an activity is cancelled, as the API names them. */
export type CancelReason =
  | 'weather'
  | 'not_enough_registrations'
  | 'organiser_unavailable'
  | 'venue_unavailable'
  | 'other';

/**
 * SMA-100: cancelling an activity, with a reason and a word for the people
 * registered.
 *
 * Called directly rather than through the generated client, like blocking and
 * reporting: the generated deleteEvent takes an id and nothing else, and
 * regenerating the client from a running API rewrites hundreds of files.
 *
 * NOTHING IS SENT WHEN NOBODY IS REGISTERED. The screen does not ask then, and
 * both fields travel as undefined, which the API reads as no reason given.
 */
@Injectable({ providedIn: 'root' })
export class CancelActivityService {
  private readonly http = inject(HttpClient);

  /**
   * The answer is the envelope every endpoint of this API sends, `{ error?,
   * value? }`, which is what the generated client describes for this same
   * route. Said here so the caller's `carriesAValue` guard has something to
   * narrow instead of `unknown`.
   */
  cancel(
    eventId: string,
    reason?: CancelReason,
    reasonCustomText?: string,
  ): Observable<{ error?: unknown; value?: unknown }> {
    return this.http.delete<{ error?: unknown; value?: unknown }>(`${environment.api}/api/v1/events/${eventId}`, {
      body: { reason, reasonCustomText },
    });
  }
}
